module.exports = __webpack_public_path__ + "static/BandagePadHand-438019fe9bf11c8ad1a55ce38a7952ae.jpg";